import './styles/style.scss';
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {Observer} from "gsap/Observer";
import './index.html'
import nav from './blocks/header_block';
import {getHeightOfViewPort} from './scripts/functions/getHeightOfViewPort';
import {initModal} from "./scripts/general/custom-modal";
import {
  detectPageVerticalScroll
} from './scripts/general/detect-page-vertical-scroll';
import {popupInit} from "./scripts/general/popup-init";
import {
  scenes,
  scenesTitles,
  audios,
  sceneNamePrefix
} from "./scripts/site_functions/constants";
import {getCurrentScene} from "./scripts/site_functions/getCurrentScene";
import loadingVideo from "./images/loading.mp4"
import carIdleAudioUrl from './audio/car_idle.mp3'
import carDrivingAudioUrl from './audio/car_driving.mp3'


let loaded = false;


function toggleAudio(playAudio) {
  if (playAudio) {
    window.audioEnabled = true;
    audios.global.map(audio => audio?.play().catch(() => console.log('global catch', audio)));
    audios[sceneNamePrefix + (window.currentScene + 1)]?.map(audio => audio?.play().catch(() => console.log('scene catch', window.currentScene + 1, audio)))
  } else {
    window.audioEnabled = false
    audios.global.map(audio => audio?.pause());
    audios[sceneNamePrefix + (window.currentScene + 1)]?.map(audio => audio?.pause())
  }
}

async function onLoad() {
  window.allowGTM = true;


// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
  const keys = {
    37: 1,
    38: 1,
    39: 1,
    40: 1,
    32: 1,
    33: 1,
    34: 1,
    35: 1,
    36: 1
  };

  function preventDefault(e) {
    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

// modern Chrome requires { passive: false } when adding event
  let supportsPassive = false;
  try {
    window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
      get: function () {
        supportsPassive = true;
      }
    }));
  } catch (e) {
  }

  const wheelOpt = supportsPassive ? {passive: false} : false;
  const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

// call this to Disable
  function disableScroll() {
    window.scrollDisabled = true;
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
  }

// call this to Enable
  function enableScroll() {
    window.scrollDisabled = false;
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);

  }

  window.addEventListener('keydown', (e) => {
    !window.scrollDisabled && e.key === 'ArrowRight' && window.scrollBy(0, 50)
    !window.scrollDisabled && e.key === 'ArrowLeft' && window.scrollBy(0, -50)
  })
  document.addEventListener('scroll-disabled', disableScroll);
  document.addEventListener('scroll-enabled', enableScroll);
  document.dispatchEvent(new Event('scroll-disabled'))


  const loaderElement = document.querySelector('.red-boat-loader');

  gsap.config({
    nullTargetWarn: false,
  });
  if (document.readyState === 'complete' && !loaded) {

    const carIdleAudio = new Audio(carIdleAudioUrl)
    const carDrivingAudio = new Audio(carDrivingAudioUrl)
    // gsap.set([carIdleAudio, carDrivingAudio], {volume: 0.3, loop: true})
    carIdleAudio.volumeTarget = 0.1;
    carIdleAudio.volume = 0.1;
    carDrivingAudio.volumeTarget = 0.1;
    carDrivingAudio.volume = 0;
    carIdleAudio.loop = true;
    carDrivingAudio.loop = true;
    audios.global.push(carIdleAudio, carDrivingAudio);
    ScrollTrigger.addEventListener('scrollStart', () => {
      if (window.carIsMoving) {
        gsap.to(carIdleAudio, {volume: 0, duration: 0.2})
        gsap.to(carDrivingAudio, {
          volume: carDrivingAudio.volumeTarget,
          duration: 0.2
        })

      }
    })
    ScrollTrigger.addEventListener('scrollEnd', () => {
      gsap.to(carDrivingAudio, {volume: 0})
      gsap.to(carIdleAudio, {volume: carIdleAudio.volumeTarget})
    })
    const audioIcon = document.querySelector(".audio-icon")

    audioIcon.addEventListener("click", () => {

      const playAudio = audioIcon.classList.toggle("un-mute")
      toggleAudio(playAudio);
    })
    loaded = true;
    gsap.registerPlugin(ScrollTrigger, Observer);
    getHeightOfViewPort();
    initModal();
    const urlSceneParam = (new URLSearchParams(window.location.search)).get('scene');
    if (urlSceneParam) {
      window.currentScene = scenesTitles.indexOf(urlSceneParam)
    }
    //region generate scene holders
    const main = document.querySelector('main');
    main.innerHTML = Object.keys(scenes).map(scene => `<div data-fetch="${scene}"></div>`).join('\n');
    //endregion generate scene holders
    window.initClickableElements = popupInit()
    const mapModel = document.querySelector(".map-model")
    const map = document.querySelector("nav.map");
    const mapModalClose = document.querySelector(".map-model .close");
    map.addEventListener("click", () => {
      mapModel.classList.add("active-model")
      mapModel.setAttribute('hidden', 'false');
      mapModel.setAttribute('area-hidden', 'false');
      mapModel.setAttribute('tabindex','0');
      mapModel.focus();
      window.allowGTM && window.dataLayer.push({
        'event': 'open-map',
        'scene': window.currentScene + 1
      });
      // region prevent page scroll
      document.documentElement.classList.add('modal-opened');
      const scrollDisabled = new Event('scroll-disabled');
      document.dispatchEvent(scrollDisabled);
      // endregion prevent page scroll
    })
    const closeMap = () => {
      mapModel.classList.remove("active-model")
      mapModel.setAttribute('hidden', 'true');
      mapModel.setAttribute('area-hidden', 'true');
      mapModel.setAttribute('tabindex','-1');
      mapModel.blur();

      // region allow page scroll
      document.dispatchEvent(new Event('scroll-enabled'));
      setTimeout(() => document.documentElement.classList.remove('modal-opened'), 50)
      // endregion allow page scroll
    }
    mapModalClose.addEventListener("click", closeMap)

    window.addEventListener('keydown', (e) => {
      if (e.key === "Escape" && document.documentElement.classList.contains('modal-opened')) {
        closeMap();
      }
    })

    const mapCirclesSmall = map.querySelectorAll("circle")
    const mapCirclesModal = mapModel.querySelectorAll(".image-wrapper circle")
    window.addEventListener('scene-map-change', () => {
      window.currentScene && map.classList.remove('inactive')
      const mapDetails = document.querySelector('section .map-data');
      const headlineData = mapDetails.querySelector(".headline")
      const descriptionData = mapDetails.querySelector(".paragraph")
      gsap.set([...mapCirclesSmall, ...mapCirclesModal], {display: 'none'})
      for (let i = 0; i < mapDetails.querySelectorAll(".map-dot-position").length; i++) {
        const dot = mapDetails.querySelectorAll(".map-dot-position")[i]
        const {posX, posY} = dot.dataset
        gsap.set(mapCirclesSmall[i], {
          display: 'block',
          attr: {cx: posX, cy: posY}
        })
        gsap.set(mapCirclesModal[i], {
          display: 'block',
          attr: {cx: posX, cy: posY}
        })
      }
      for (let dot of mapDetails.querySelectorAll(".map-dot-position")) {


      }

      const mapHeadline = mapModel.querySelector(".headline")
      const mapDescription = mapModel.querySelector(".paragraph")

      mapHeadline.textContent = headlineData.textContent
      mapDescription.innerHTML = descriptionData.innerHTML
      mapDetails.remove();
    })
    // fixContainer();
    detectPageVerticalScroll();
    ScrollTrigger.config({ignoreMobileResize: true});
    ScrollTrigger.normalizeScroll()
    await getCurrentScene(window.currentScene)

    await nav();

    window.addEventListener('popstate', event => {
      loaderElement.classList.add('active')
      getCurrentScene(window.currentScene = event.state.sceneIndex, false, true);
    })


    document.body.classList.add('loaded');
    const loaderVideoElement = loaderElement.querySelector("video");
    loaderVideoElement && (loaderVideoElement.src = loadingVideo)
    Observer.create({
      type: "touch,pointer",
      onChangeX({deltaX}) {
        window.scrollDisabled || window.scrollBy(0, -deltaX * 3)
      },
      preventDefault: true,
    });

    window.addEventListener('keydown', e => {
      e.code === "Enter" && e.target.dispatchEvent(new Event('click'));
    })


    setTimeout(() => window.scrollTo(0, 0), 200)
  }

}

onLoad();

document.onreadystatechange = function () {
  onLoad();
};


